// @flow

export type SelectOptionValueProp = string | number | null;

export type SelectOptionProp = {
    displayText: string,
    id?: string,
    value: SelectOptionValueProp,
};
